import React, { useEffect, useState } from 'react'
import Breadcrum from '../../components/breadcrum'
import AddItem from '../../components/addItem'
import DsjInsight from '../../components/DsjInsight'
import { useQuery } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { getAllLatest, getAllHideLatest } from '../../api/latestApi'
import { FaEye, FaEyeSlash, FaSearch } from 'react-icons/fa'

const LatestDeal = () => {
  const [showHidden, setShowHidden] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    document.title = 'Latest Deal'
  }, [])

  // Conditionally fetch data based on toggle
  const {
    data: latestData = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['latestdealData', showHidden],
    queryFn: () => (showHidden ? getAllHideLatest() : getAllLatest()),
    onError: () => {
      toast.error('Error fetching latest deals')
    },
  })

  console.log('latestData is this', latestData)

  const filteredUsers =
    latestData?.filter((latest) => {
      const matchesSearch =
        latest.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        latest.cin?.toLowerCase().includes(searchTerm.toLowerCase())

      let matchesMonth = false
      if (latest.createdAt) {
        const date = new Date(latest.createdAt)
        const monthName = date
          .toLocaleDateString('default', {
            month: 'long',
          })
          .toLowerCase()
        matchesMonth = monthName.includes(searchTerm.toLowerCase())
      }

      return matchesSearch || matchesMonth
    }) || []

  const handleToggle = () => {
    setShowHidden((prev) => !prev)
  }

  if (isLoading) {
    return (
      <>
        <Breadcrum heading="Insight" subheading="Latest Deal" />
        <div className="text-center py-8">Loading latest deals...</div>
      </>
    )
  }

  if (isError) {
    return (
      <>
        <Breadcrum heading="Insight" subheading="Latest Deal" />
        <div className="text-center py-8 text-red-500">
          Error loading latest deals. Please try again later.
        </div>
      </>
    )
  }

  return (
    <>
      <Breadcrum subheading="Latest Deal" heading="Insight" />

      {showHidden ? '' : <AddItem redirect="/dealdashboard/add/latestDeal" />}

      {/* Search and Filter Section */}
      <div className="md:w-[90%] mx-auto my-6">
        <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 relative">
              <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
              <input
                type="text"
                placeholder="Search by company Name/Created Month/Cin..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#ff7010] focus:border-transparent outline-none transition-all"
              />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-500">
            Showing {filteredUsers.length} of {latestData.length} Reports
          </div>
        </div>
      </div>

      <div className="fixed right-10 top-[18%] font-aptos-regular bg-[#ff7010] rounded-full text-white text-xl w-fit h-fit px-2 py-1 shadow-md">
        {latestData.length}
      </div>

      <div className="md:w-[90%] mx-auto flex justify-between items-center">
        <h2
          className={`text-2xl font-aptos-semibold ${
            showHidden ? 'text-red-600' : 'text-gray-600'
          }`}
        >
          {showHidden ? 'Hidden' : 'Active'} Files
        </h2>

        <button
          onClick={handleToggle}
          title={showHidden ? 'Show active reports' : 'Show hidden reports'}
          className="text-white bg-blue-500 p-2 rounded hover:bg-blue-700 transition-colors"
        >
          {showHidden ? <FaEye /> : <FaEyeSlash />}
        </button>
      </div>

      <DsjInsight data={filteredUsers} />

      {showHidden ? '' : <AddItem redirect="/dealdashboard/add/latestDeal" />}
    </>
  )
}

export default LatestDeal
